import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// material
import {
  Button,
  Card,
  Checkbox,
  Container,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TablePagination,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
// components
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import BrudCrumbs from '../../components/BreadCrumbs';
import Label from '../../components/Label';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
import { NOT_AVAILABLE } from '../Global/Constants';
import Loader from '../Global/Loader';
import { fDate, fDateNew, fDateTime2 } from '../../utils/formatTime';
import LeadsToolbar from './LeadsToolbar';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import { getLeadGridData, getLeadListStatus } from '../../store/Slice/Lead/LeadSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useLeadSelector from '../../store/Slice/Lead/LeadSelector';
import {
  getCityData,
  getInternalSaleManager,
  getLoanTypeData,
  getMasterListType
} from '../../store/Slice/Global/GlobalSlice';
import { isValidValue, normalizeValue } from '../../utils/CommonFunction';
import leadsService from '../services/leadsService';
import SimplePagination from '../../components/SimplePagination';
import useDebounce from '../../utils/useDebounce';

const { AssignLeads } = leadsService;

const TABLE_HEAD = [
  { id: 'leadId', label: 'Lead ID', alignRight: false },
  { id: 'created', label: 'Lead Date', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'loanType', label: 'Loan Type', alignRight: false },
  { id: 'users', label: 'City', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'leadSource', label: 'Lead Source', alignRight: false },
  { id: 'statusLeads', label: 'status', alignRight: false },
  { id: 'applicantType', label: 'Applicant Type', alignRight: false },
  { id: 'created', label: 'Last update', alignRight: false },
  { id: 'action', label: 'ACTION' }
];

// ----------------------------------------------------------------------

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 13,
    fontWeight: 'normal',
    padding: '6px'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: 4
  }
}));

/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function Leads() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page1, setPage1] = useState(1);
  const [selectProduct, setSelectProduct] = useState(' ');
  const [selectStatus, setSelectStatus] = useState(' ');
  const [selectSource, setSelectSource] = useState(' ');
  const [selectLeadSource, setSelectLeadSource] = useState(' ');
  const [pageMenu, setPageMenu] = useState([]);
  const [stateListMenu, setStateListMenu] = useState([]);
  const [cityListData, setCityListData] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openAssign, setOpenAssign] = useState(false);
  const [assignValue, setAssignValue] = useState(' ');
  const [validationMsg, setValidationMsg] = useState('');
  const [alertMsg, setAlertMsg] = useState(false);
  const [filterDatesRange, setFilterDatesRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [hasNextPage, setHasNextPage] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const debouncedSearch = useDebounce(filterName, 1000);

  const { LoginData } = useLoginSelector();
  const { LeadGridData } = useLeadSelector();
  const leadsListResponse = LeadGridData || [];
  // console.log('leadsListResponse22', leadsListResponse);
  const totalCount = leadsListResponse?.length || 0;

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = leadsListResponse
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // source leads field
  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // select product field
  const handleSelectProduct = (e) => {
    setSelectProduct(e.target.value);
  };

  // select status
  const handleSelectStatus = (e) => {
    setSelectStatus(e.target.value);
  };

  // select source
  const handleSelectSource = (e) => {
    setSelectSource(e.target.value);
  };

  const handleSelectLeadSource = (e) => {
    setSelectLeadSource(e.target.value);
  };

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - leadsListResponse.length) : 0;

  const handleClick = (event, item) => {
    const selectedIndex = selected.indexOf(item);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleAssignSubmit = async (e) => {
    if (assignValue === ' ') {
      setAlertMsg(true);
      return true;
    }
    const newArray = [];
    selected.forEach((item) => {
      const obj = {
        leadId: item.leadId,
        stageId: 56,
        leadStageStatusId: item.leadStageStatusId,
        assignedTo: assignValue
      };
      newArray.push(obj);
    });
    const credential = {
      assignableLeads: newArray
    };

    const AssignLeadsApiResponse = await AssignLeads(credential, LoginData?.jwt);
    if (AssignLeadsApiResponse.msg) {
      if (AssignLeadsApiResponse.msg === 'Forbidden') {
        navigate('/');
      }
    }
    if (AssignLeadsApiResponse.status === 'success') {
      navigate('/leads');
      setAssignValue(' ');
      setOpenAssign(false);
      getLeadListApi(); // get latest update list
      setSelected([]);
    } else {
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
      setOpenAssign(false);
    }
  };

  useEffect(() => {
    const leadDetails = localStorage.getItem('leadDetails');
    const allDocumentList = localStorage.getItem('allDocumentList');
    if (allDocumentList !== null) {
      localStorage.removeItem('allDocumentList');
    }

    if (leadDetails !== null) {
      localStorage.removeItem('leadDetails');
    }
    setTimeout(() => {
      localStorage.removeItem('fromRecommendationTab');
    }, 1000);
  }, []);

  // lead list
  const getLeadListApi = useCallback(() => {
    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      stageId: 56,

      leadFilterModel: {
        fromLeadDate:
          filterDatesRange[0].startDate !== null ? fDateTime2(filterDatesRange[0].startDate) : null,
        toLeadDate:
          filterDatesRange[0].endDate !== null ? fDateTime2(filterDatesRange[0].endDate) : null,
        leadStatusId: selectStatus !== ' ' ? selectStatus : null,
        campaignSourceId: selectSource !== ' ' ? selectSource : null,
        leadRouteTypeId: selectLeadSource !== ' ' ? selectLeadSource : null,
        cityId: cityListData === null ? null : cityListData.cityId,
        loanTypeId: selectProduct !== ' ' ? selectProduct : null
      },

      entityListRequestModel: {
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null,
        pageSize: rowsPerPage,
        pageNumber: page + 1,
        sortOrder: order
      }
    };

    dispatch(getLeadGridData(credentials));
  }, [
    LoginData,
    filterDatesRange,
    selectStatus,
    selectSource,
    rowsPerPage,
    page,
    order,
    selectProduct,
    selectLeadSource,
    cityListData,
    debouncedSearch
  ]);

  //  city api
  const handleGetState = (optionVal) => {
    const data = {
      stateId: optionVal
    };
    dispatch(getCityData(data)); // city data
  };

  // internal sale manager list
  const getInternalSaleManagerData = useCallback(() => {
    if (!LoginData?.companyId) return; // safety check
    const data = {
      companyId: LoginData?.companyId
    };
    dispatch(getInternalSaleManager(data));
  }, [LoginData]);

  // lead list status
  const getLeadListStatusApi = () => {
    const credential = {
      stageId: 56
    };
    dispatch(getLeadListStatus(credential));
  };

  // Master Type List
  const getMasterTypeListApi = () => {
    const type = 'LEAD_ROUTE_TYPE';
    dispatch(getMasterListType(type));
  };

  // loan type
  const getLoanMasterApi = useCallback(() => {
    const obj = {
      companyId: LoginData?.companyId
    };
    dispatch(getLoanTypeData(obj));
  }, [LoginData]);

  useEffect(() => {
    getLeadListApi(); // call center list
    getLoanMasterApi(); // loan master list
    getLeadListStatusApi(); // lead list status
    getMasterTypeListApi(); // Master Type List
    getInternalSaleManagerData(); // Internal Sales Manager Data
    handleGetState(null); // get city list
  }, [getLeadListApi]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setHasNextPage(true);
  };

  useEffect(() => {
    if (leadsListResponse?.length < rowsPerPage) {
      setHasNextPage(false); // last page reached
    } else {
      setHasNextPage(true);
    }
  }, [leadsListResponse, rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);

  return (
    <Page title="Kpros by Kalolytic Solutions || Leads">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Leads" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Card>
            <LeadsToolbar
              numSelected={selected.length}
              filterName={filterName}
              setFilterName={setFilterName}
              onFilterName={handleFilterByName}
              selectProduct={selectProduct}
              setSelectProduct={setSelectProduct}
              onFilterProduct={handleSelectProduct}
              selectStatus={selectStatus}
              setSelectStatus={setSelectStatus}
              onFilterStatus={handleSelectStatus}
              selectSource={selectSource}
              setSelectSource={setSelectSource}
              onFilterSource={handleSelectSource}
              selectLeadSource={selectLeadSource}
              setSelectLeadSource={setSelectLeadSource}
              onFilterLeadSource={handleSelectLeadSource}
              parent="leads"
              selected={selected}
              pageMenu={pageMenu}
              stateListMenu={stateListMenu}
              filterDatesRange={filterDatesRange}
              setFilterDatesRange={setFilterDatesRange}
              cityListData={cityListData}
              setCityListData={setCityListData}
              onAssignSubmit={handleAssignSubmit}
              openAssign={openAssign}
              setOpenAssign={setOpenAssign}
              assignValue={assignValue}
              setAssignValue={setAssignValue}
              validationMsg={validationMsg}
              setValidationMsg={setValidationMsg}
              alertMsg={alertMsg}
              setAlertMsg={setAlertMsg}
              leadsListResponse={leadsListResponse} // prashant
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, height: '50vh', overflow: 'auto' }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={leadsListResponse?.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    isCheckBox="true"
                  />
                  <TableBody>
                    {leadsListResponse && leadsListResponse.length > 0
                      ? leadsListResponse?.map((item, index) => {
                          const isItemSelected = selected.indexOf(item) !== -1;
                          return (
                            <StyledTableRow
                              hover
                              key={index}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) => handleClick(event, item)}
                                />
                              </TableCell>
                              <StyledTableCell align="left">
                                {item.leadId ? item.leadId : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {isValidValue(item.leadDate)
                                  ? fDate(item.leadDate)
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item.customerName ? item.customerName : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item.loanType ? item.loanType : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item.city ? item.city : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item.loanAmountRequested
                                  ? item.loanAmountRequested
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item.leadRouteTypeName
                                  ? item.leadRouteTypeName
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  // variant="filled"
                                  color={
                                    // (item.stageStatusName === 'New' && 'leadsnew') ||
                                    (item.stageStatusName === 'New' && 'greymsg') ||
                                    (item.stageStatusName === 'Contacted' && 'greymsg') ||
                                    (item.stageStatusName === null && 'error') ||
                                    (item.stageStatusName === 'Not Interested' && 'error') ||
                                    (item.stageStatusName === 'Not Contactable' && 'greymsg') ||
                                    (item.stageStatusName === 'Partial Complete' && 'greymsg') ||
                                    (item.stageStatusName === 'Completed' && 'success') ||
                                    (item.stageStatusName === 'Submitted' && 'success') ||
                                    'warning'
                                  }
                                >
                                  {item.leadStatus ? item.leadStatus : `${NOT_AVAILABLE}`}
                                </Label>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.employmentType, `${NOT_AVAILABLE}`)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(
                                  fDateNew(item?.leadLastUpdatedOn),
                                  `${NOT_AVAILABLE}`
                                )}
                              </StyledTableCell>
                              <StyledTableCell align="" width={115}>
                                <UserMoreMenu
                                  rowId={item.leadId}
                                  assignedTo={item.assignedTo}
                                  parent="leads"
                                  companyId={item.companyId}
                                  applicationId={item.applicationId}
                                  // pageMenu={pageMenu}
                                  itemObj={item}
                                />
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })
                      : ''}

                    {/* {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <StyledTableCell colSpan={6} />
                      </TableRow>
                    )} */}
                  </TableBody>
                  {leadsListResponse?.length === 0 && (
                    <TableBody>
                      <TableRow>
                        <StyledTableCell
                          align="center"
                          colSpan={TABLE_HEAD.length + 1}
                          sx={{ py: 3 }}
                        >
                          <SearchNotFound searchQuery={filterName} />
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            {/* <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: 1.5,
                px: 2,
                py: 1.5,
                borderTop: '1px solid',
                borderColor: 'divider'
              }}
            >
              <Tooltip title="Previous page">
                <span>
                  <IconButton
                    size="small"
                    disabled={page === 0}
                    onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                  >
                    <KeyboardArrowLeft />
                  </IconButton>
                </span>
              </Tooltip>

              <Typography variant="body2" color="text.secondary">
                Page <strong>{page + 1}</strong>
              </Typography>

              <Tooltip title="Next page">
                <span>
                  <IconButton
                    size="small"
                    disabled={!hasNextPage}
                    onClick={() => setPage((prev) => prev + 1)}
                  >
                    <KeyboardArrowRight />
                  </IconButton>
                </span>
              </Tooltip>
            </Box> */}

            <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
          </Card>
          <Loader openLoader={openLoader} />

          <ApiErrorMessage
            openApiError={openApiError}
            setOpenApiError={setOpenApiError}
            errorMessage={errorMessage}
          />
        </Box>
      </Container>
    </Page>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ paddingTop: '1rem' }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
